export enum S1DataTransferFolder {
    FTP, EDT
}